export const role = [
    {value: 'Admin', label: 'Admin'},
    {value: 'Operator', label: 'Operator'},
    {value: 'Aspirant', label: 'Aspirant'},
    {value: 'Employee', label: 'Employee'}
]